import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=4ea74e07&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=4ea74e07&lang=less&scoped=true&"
import style1 from "./comment.vue?vue&type=style&index=1&id=4ea74e07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea74e07",
  null
  
)

export default component.exports